import React, { Component } from 'react';
import './Circle.scss'

class Circle extends Component {
	render() {
		return (
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				preserveAspectRatio="xMinYMax meet"
				viewBox="0 0 377.5 377.5"
				className="circle" 
				space="preserve">
				
				<defs>
					<pattern
						id={this.props.id}
						patternUnits="userSpaceOnUse"
						width="100%"
						height="100%">
						<image
							xlinkHref={this.props.image}
							preserveAspectRatio="xMinYMin slice"
							width="100%"
							height="100%" />
					</pattern>
				</defs>
							
				<circle
					fill={`url(#${this.props.id})`}
					cx="188.8"
					cy="188.8"
					r="188.8"
					className="background" />

			{/* <a href="#">
				<circle className="a-circle" cx="19.3" cy="102.8" r="19.3" />
				<g>
					<path style={{ fill: "#FFFFFF" }} d="M21.8,99.8v7c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1l-3.5-3.5
						c-0.1-0.1-0.1-0.2-0.1-0.4s0-0.3,0.1-0.4l3.5-3.5c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1C21.8,99.6,21.8,99.7,21.8,99.8z"/>
				</g>
			</a> */}
			
			{/* <a href="#">
				<circle className="a-circle"  cx="358.3" cy="102.8" r="19.3" />
				<g>
					<path style={{ fill: "#FFFFFF" }} d="M360.3,103.3c0,0.1,0,0.3-0.1,0.4l-3.5,3.5c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1
						c-0.1-0.1-0.1-0.2-0.1-0.4v-7c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1l3.5,3.5
						C360.2,103.1,360.3,103.2,360.3,103.3z"/>
				</g>
			</a> */}
				
			<path style={{ fill: "#9AC743" }} d="M157.7,318.8H26.2c-5.1,0-9.3,4.2-9.3,9.3v30.5c0,5.1,4.2,9.3,9.3,9.3h131.5c5.1,0,9.3-4.2,9.3-9.3v-30.5
				C166.9,323,162.8,318.8,157.7,318.8z"/>

			<path 
				className="title-holder"
				style={{ fill: "#0E5F7C" }} 
				d="M325.3,337.8H18.8C8.4,337.8,0,329.3,0,319v-35.8c0-10.3,8.4-18.8,18.8-18.8h306.5c10.3,0,18.8,8.4,18.8,18.8
				V319C344,329.3,335.6,337.8,325.3,337.8z"/>

				<circle style={{ fill: "#FFFFFF" }} cx="330.3" cy="301.1" r="47.2" />
				
				<rect x="283.1" y="275.8" style={{ fill: "none" }} width="93.5" height="71.5" />
				
				<text transform="matrix(1 0 0 1 305.1136 289.4959)" style={{ fontFamily: "Roboto", fill: "#000000", fontWeight:300, fontSize: '18px' }}>{this.props.month}</text>
				
				<rect x="283.1" y="302" style={{ fill: "none" }} width="93.5" height="71.5" />
				
				<text transform="matrix(1 0 0 1 305.1615 319.5758)" style={{ fontFamily: "Roboto", fill: "#000000", fontWeight:600, fontSize: '23px' }}>{this.props.year}</text>
				
				<rect x="30" y="346.8" style={{ fill: "none" }} width="137" height="21.1" />
				
				<text transform="matrix(1 0 0 1 30 357.4579)" style={{ fontFamily: "Roboto", fill: "#FFFFFF", fontWeight:500, fontSize: '14px' }}>{this.props.desc}</text>
				
				<rect x="16.9" y="284.9" style={{ fill: "none" }} width="279.3" height="67.8" />
				
				<text transform="matrix(1 0 0 1 16.9 298.6041)">
					<tspan x="0" y="0" style={{ fontFamily: "Roboto", fill: "#FFFFFF", fontWeight:500, fontSize: '18px' }}>{this.props.title1}</tspan>
					<tspan x="0" y="21.6" style={{ fontFamily: "Roboto", fill: "#FFFFFF", fontWeight:500, fontSize: '18px' }}>{this.props.title2}</tspan>
				</text>
			<g>
				<path style={{ fill: "#FFFFFF" }} d="M153.1,353.6c0,0.1,0,0.1-0.1,0.2l-3.6,3.6c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2-0.1l-0.4-0.4
					c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.1,0.1-0.2l3.1-3.1l-3.1-3.1c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.1,0.1-0.2l0.4-0.4
					c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0.1l3.6,3.6C153.1,353.5,153.1,353.5,153.1,353.6z M156.1,353.6c0,0.1,0,0.1-0.1,0.2
					l-3.6,3.6c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2-0.1l-0.4-0.4c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.1,0.1-0.2l3.1-3.1l-3.1-3.1
					c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.1,0.1-0.2l0.4-0.4c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0.1l3.6,3.6
					C156.1,353.5,156.1,353.5,156.1,353.6z"/>
			</g>
			
			
			</svg>

		);
	}
}

export default Circle;


// WEBPACK FOOTER //
// ./src/Pages/Home/Circle.js